
import React, { useEffect, useState } from 'react';

interface QRCodeProps {
  value: string;
  size?: number;
  backgroundColor?: string;
  foregroundColor?: string;
}

const QRCode: React.FC<QRCodeProps> = ({
  value,
  size = 200,
  backgroundColor = '#ffffff',
  foregroundColor = '#000000'
}) => {
  const [qrDataUrl, setQrDataUrl] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadQRCode = async () => {
      try {
        // Dynamically import QRious
        const QRious = (await import('qrious')).default;
        
        // Create canvas
        const qr = new QRious({
          value,
          size,
          background: backgroundColor,
          foreground: foregroundColor,
          level: 'H' // highest error correction level
        });
        
        // Get data URL
        setQrDataUrl(qr.toDataURL());
      } catch (error) {
        console.error('Error generating QR code:', error);
      } finally {
        setIsLoading(false);
      }
    };
    
    loadQRCode();
  }, [value, size, backgroundColor, foregroundColor]);

  if (isLoading) {
    return (
      <div 
        style={{ width: size, height: size }}
        className="animate-pulse bg-gray-800 rounded-md"
      ></div>
    );
  }

  return qrDataUrl ? (
    <img 
      src={qrDataUrl} 
      alt="QR Code"
      width={size} 
      height={size}
      className="rounded-md"
    />
  ) : (
    <div 
      style={{ width: size, height: size }}
      className="bg-gray-800 rounded-md flex items-center justify-center"
    >
      <span className="text-sm text-gray-400">Could not generate QR code</span>
    </div>
  );
};

export default QRCode;
